module.exports = __webpack_public_path__ + "static/media/silvasa2.00f19148.webp";